import fetchPhraseIfNeeded from 'helpers/utils/fetch-phrase-if-needed';
import { getLists } from 'adapters/list';
import {
    ADD_ITEMS_REQUEST,
    ADD_REQUEST,
    FavouritesPayload,
    MultipleItemPayload,
    UPDATE_DATA,
    UpdateDataEvent,
    UpdateDataPayload,
    subscribe,
} from 'helpers/pubsub';
import { addToList } from './addToList';
import { GetListsQuery } from 'adapters/list/graphqlTypes';
import { updateMultiListStore } from 'helpers/store';
import { reportError } from 'helpers/sentry';

const handleAddToListSubscription = (payload: FavouritesPayload) => {
    return Promise.all([
        import('./bootAddToList'),
        getLists(),
        fetchPhraseIfNeeded(),
    ])
        .then(([{ boot }, res]) => {
            if (res.data.lists.length <= 1 && !payload.alwaysShowModal) {
                return addToList(payload);
            }
            return boot(payload, res.data.lists as GetListsQuery['lists']);
        })
        .catch(e => {
            reportError(e as Error);
            throw Error('Could not add to favourites');
        });
};

const handleUpdateDataSubscription = (payload: UpdateDataPayload) => {
    if (payload.source === 'favourites') {
        updateMultiListStore(payload.data);
    }
};

export const initAddToList = () => {
    subscribe(ADD_REQUEST, handleAddToListSubscription);
    subscribe(ADD_ITEMS_REQUEST, handleAddToListSubscription);
    subscribe<UpdateDataEvent>(UPDATE_DATA, handleUpdateDataSubscription);
    return (payload: MultipleItemPayload) =>
        handleAddToListSubscription(payload);
};
